import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import API_URL from "../config";
 
const EyeIcon = ({ open }) => open ? (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
  </svg>
) : (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);
 
export default function Login() {
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword]     = useState("");
  const [error, setError]           = useState("");
  const [loading, setLoading]       = useState(false);
  const [showPassword, setShowPassword] = useState(false);
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ identifier, password }),
      });
      const data = await res.json();
      if (!res.ok) return setError(data.message);
 
      localStorage.setItem("token", data.token);
      localStorage.setItem("username", data.username);
      localStorage.setItem("role", data.role);
 
      if (data.role === "admin") navigate("/admin");
      else navigate("/");
    } catch {
      setError("Impossible de contacter le serveur.");
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "var(--bg)" }}>
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="eyebrow">Espace membre</span>
          <h1 style={{ color: "#E0392B", fontFamily: "var(--font-display)", WebkitTextStroke: "1.5px var(--ink)", textShadow: "3px 3px 0 var(--ink)", fontSize: "2.5rem", lineHeight: 1.05 }}>Connexion</h1>
        </div>
 
        <div className="brut-card p-8">
          <p className="text-center font-medium mb-6" style={{ color: "var(--ink-soft)" }}>
            Connectez-vous avec votre email ou nom d'utilisateur
          </p>
 
          {error && (
            <div className="mb-5 p-3 rounded-lg text-sm font-bold" style={{ background: "#fee2e2", border: "2px solid #dc2626", color: "#991b1b" }}>
              ⚠️ {error}
            </div>
          )}
 
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="brut-label">Email ou nom d'utilisateur</label>
              <input type="text" value={identifier} onChange={(e) => setIdentifier(e.target.value)}
                required placeholder="jean@email.com ou jean123" className="brut-input" />
            </div>
            <div>
              <label className="brut-label">Mot de passe</label>
              <div style={{ position: "relative" }}>
                <input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)}
                  required placeholder="••••••••" className="brut-input" style={{ paddingRight: "2.8rem" }} />
                <button
                  type="button"
                  onClick={() => setShowPassword(v => !v)}
                  style={{
                    position: "absolute", right: "0.75rem", top: "50%", transform: "translateY(-50%)",
                    background: "none", border: "none", cursor: "pointer",
                    color: "var(--ink-soft)", display: "flex", alignItems: "center", padding: 0,
                  }}
                  aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                >
                  <EyeIcon open={showPassword} />
                </button>
              </div>
            </div>
            <button type="submit" disabled={loading}
              className="brut-btn brut-btn-primary w-full justify-center disabled:opacity-50">
              {loading ? "Connexion..." : "Se connecter →"}
            </button>
          </form>
 
          <p className="text-center text-sm font-medium mt-6" style={{ color: "var(--ink-soft)" }}>
            Pas encore de compte ?{" "}
            <Link to="/register" style={{ color: "var(--primary)", fontWeight: 700 }}>S'inscrire</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
 